var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{class:_vm.row.class},_vm._l((_vm.visibleCols(_vm.row)),function(col){return _c('form-column',_vm._g({key:col.key,attrs:{"col":col,"fields":_vm.fields,"data":_vm.data,"attachments":_vm.attachments,"buttons":_vm.buttons}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }